import {
  Badge,
  HStack,
  NumberInput,
  NumberInputField,
  Switch,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';
import * as PropTypes from 'prop-types';

/**
 *
 * @param {any}}input
 * @param {function}handleChangeInput
 * @return {JSX.Element}
 * @constructor
 */
export const InputDataStore = ({ input, handleChangeInput }) => {
  return (
    <HStack spacing={16} justify={'center'} align={'center'}>
      <VStack align={'flex-start'}>
        <Text as="b">Order per month: </Text>
        <NumberInput
          min={0}
          keepWithinRange={false}
          clampValueOnBlur={false}
          value={input.orderPerMonth}
          onChange={val => handleChangeInput('orderPerMonth', val)}
          allowMouseWheel
          aria-label={'Order per month'}
          title={'Order per month'}
          w={150}
        >
          <NumberInputField />
        </NumberInput>
      </VStack>
      <VStack align={'flex-start'}>
        <Text as="b">Average order value: </Text>
        <NumberInput
          min={0}
          keepWithinRange={false}
          clampValueOnBlur={false}
          value={input.avgOrderValue}
          onChange={val => handleChangeInput('avgOrderValue', val)}
          allowMouseWheel
          aria-label={'Monthly revenue'}
          title={'Monthly revenue'}
          w={150}
        >
          <NumberInputField />
        </NumberInput>
      </VStack>
      <HStack pt={8}>
        <Text>Monthly</Text>
        <Switch
          isChecked={input.isPlanYearly}
          size="lg"
          onChange={e => handleChangeInput('isPlanYearly', e.target.checked)}
        />
        <Text>Yearly</Text>
        <Badge ml="1" fontSize="0.8em" colorScheme="green">
          Save 25%
        </Badge>
      </HStack>
    </HStack>
  );
};

InputDataStore.propTypes = {
  input: PropTypes.shape({
    orderPerMonth: PropTypes.number,
    typePaymentGateway: PropTypes.string,
    isPlanYearly: PropTypes.bool,
    avgOrderValue: PropTypes.number,
  }),
  handleChangeInput: PropTypes.func,
};
